"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spotOrderRawToSpotOrderMapper = exports.getSpotOrderPrice = exports.sporOrderUpdateToSpotOrderMapper = exports.spotMarketIndividualTickerRawToIndividualTickerMapper = exports.spotAccountUpdateRawToAccountUpdateMapper = exports.spotOrderUpdateRawToOrderUpdateMapper = void 0;
const binance_1 = require("../../types/binance");
const spotOrderUpdateRawToOrderUpdateMapper = (order) => {
    return {
        eventType: order.e,
        eventTime: order.E,
        symbold: order.s,
        clientOrderId: order.c,
        orderId: order.i,
        orderListId: order.g,
        side: order.S,
        type: order.o,
        origQty: order.q,
        lastExecutedQty: order.l,
        price: order.p,
        stopPrice: order.P,
        lastExecutedPrice: order.L,
        creationTime: order.O,
        cumulativeFilledQty: order.z,
        cummulativeQuoteQty: order.Z,
        status: order.X,
    };
};
exports.spotOrderUpdateRawToOrderUpdateMapper = spotOrderUpdateRawToOrderUpdateMapper;
const spotAccountUpdateRawToAccountUpdateMapper = (event) => {
    return {
        eventType: event.e,
        eventTime: event.E,
        balances: event.B.map(balanceRaw => {
            return {
                asset: balanceRaw.a,
                free: balanceRaw.f,
                locked: balanceRaw.l,
            };
        }),
        lastAccountUpdateTime: event.u,
    };
};
exports.spotAccountUpdateRawToAccountUpdateMapper = spotAccountUpdateRawToAccountUpdateMapper;
const spotMarketIndividualTickerRawToIndividualTickerMapper = (event) => {
    return {
        eventType: event.e,
        eventTime: event.E,
        bestAskPrice: event.a,
        bestAskQuantity: event.A,
        bestBidPrice: event.b,
        bestBidQuantity: event.B,
        firstTradeId: event.F,
        firstTradePrice: event.x,
        highPrice: event.h,
        lastPrice: event.c,
        lastQuantity: event.Q,
        lastTradeId: event.L,
        lowPrice: event.l,
        openPrice: event.o,
        priceChange: event.p,
        priceChangePercent: event.P,
        statsCloseTime: event.C,
        statsOpenTime: event.O,
        symbol: event.s,
        totalTradesNumber: event.n,
        totalTradedBaseVolume: event.v,
        totalTradedQuoteVolume: event.q,
        weightedAveragePrice: event.w,
    };
};
exports.spotMarketIndividualTickerRawToIndividualTickerMapper = spotMarketIndividualTickerRawToIndividualTickerMapper;
//TODO:remove
const sporOrderUpdateToSpotOrderMapper = (orderUpdate) => {
    return {
        symbol: orderUpdate.symbold,
        orderId: orderUpdate.orderId,
        price: orderUpdate.price,
        origQty: orderUpdate.origQty,
        executedQty: orderUpdate.cumulativeFilledQty,
        status: orderUpdate.status,
        type: orderUpdate.type,
        side: orderUpdate.side,
        time: orderUpdate.creationTime,
        updateTime: orderUpdate.eventTime,
        stopPrice: orderUpdate.stopPrice,
        priceOutput: (0, exports.getSpotOrderPrice)({
            type: orderUpdate.type,
            price: orderUpdate.price,
            stopPrice: orderUpdate.stopPrice
        })
    };
};
exports.sporOrderUpdateToSpotOrderMapper = sporOrderUpdateToSpotOrderMapper;
const getSpotOrderPrice = (params) => {
    const stopPriceTypes = [binance_1.ESpotOrderType.STOP_LOSS, binance_1.ESpotOrderType.STOP_LOSS_LIMIT, binance_1.ESpotOrderType.TAKE_PROFIT, binance_1.ESpotOrderType.TAKE_PROFIT_LIMIT];
    switch (true) {
        case stopPriceTypes.includes(params.type):
            return params.stopPrice;
        default:
            return params.price;
    }
};
exports.getSpotOrderPrice = getSpotOrderPrice;
const spotOrderRawToSpotOrderMapper = (orderUpdate) => {
    return Object.assign(Object.assign({}, orderUpdate), { priceOutput: (0, exports.getSpotOrderPrice)({
            type: orderUpdate.type,
            price: orderUpdate.price,
            stopPrice: orderUpdate.stopPrice
        }) });
};
exports.spotOrderRawToSpotOrderMapper = spotOrderRawToSpotOrderMapper;
